import { Component } from '@angular/core';
import { soundpostAgreementLineEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Agreement Lines') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostagreementline-form',
    templateUrl: './soundpostagreementline.form.component.html'
})
export class soundpostAgreementLineFormComponent extends BaseFormComponent {
    public record!: soundpostAgreementLineEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

